import InlineReplacement from './base/inline-replacement';
import AttributeReplacer from '@intercom/embercom-composer/lib/attribute-replacer';
export default InlineReplacement.extend().reopenClass({
  delimiter: /(^|\s)[^\s]*$/,
  tryReplacementWithIndex(block) {
    this.tryReplacement(block);
  },
  tryReplacement(block, mutationResult) {
    if (block.get('config.allowAttribute')) {
      let attributeReplacer = new AttributeReplacer(block);
      attributeReplacer.replaceAttributes(mutationResult);
    }
  }
});